var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path44, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeogrowthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1e1c;}.cls-2{fill:#379b47;}.cls-3,.cls-4{fill:none;}.cls-4{stroke:#000;stroke-miterlimit:10;stroke-width:0.42px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.81,659h4.84v41.4h21.57v4.3H90.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.78,701.27a11.34,11.34,0,0,0,8.8-3.7l2.89,2.82c-2.55,2.89-6.25,4.84-11.69,4.84-9.14,0-15.06-6.32-15.06-14.45a14.27,14.27,0,0,1,14.39-14.52c8.94,0,14.31,6.86,14,16.07H126.43C127,697.64,130.66,701.27,136.78,701.27Zm8.6-12.51c-.4-4.77-3.42-8.53-9.27-8.53-5.31,0-8.87,3.43-9.61,8.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.35,676.87h4.71l-.14,5.71a10.67,10.67,0,0,1,10-6.32c6.18,0,10.41,4.24,10.41,11.5v16.93h-4.7v-16.4c0-4.9-2.29-7.73-6.92-7.73-5.18,0-8.67,3.3-8.67,8.81v15.32h-4.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.48,690.71c0-8.26,5.92-14.45,13.45-14.45a11.43,11.43,0,0,1,10.68,6.32V656.17h4.64v48.52h-4.64l.14-6A11.71,11.71,0,0,1,205,705.23C197.4,705.23,191.48,699.05,191.48,690.71Zm24.34,0c0-6-4-10.28-9.89-10.28s-9.61,4.3-9.61,10.28,3.77,10.42,9.61,10.42S215.82,696.76,215.82,690.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.59,665.51a3.36,3.36,0,0,1,6.72,0,3.36,3.36,0,0,1-6.72,0Zm1,11.36h4.7v27.82h-4.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.59,676.87h4.7l-.13,5.71a10.66,10.66,0,0,1,10-6.32c6.18,0,10.42,4.24,10.42,11.5v16.93h-4.71v-16.4c0-4.9-2.28-7.73-6.92-7.73-5.17,0-8.67,3.3-8.67,8.81v15.32h-4.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305,676.87v3.56h-5.45a8.05,8.05,0,0,1,2.22,5.71c0,5.72-4.37,10-10.82,10a11.85,11.85,0,0,1-5.71-1.28,2.86,2.86,0,0,0-2.29,2.83c0,1.81,1.28,2.68,3.63,2.82l7.13.54c7.93.6,11.69,3.49,11.69,8.8,0,6.05-5.58,9.88-14.79,9.88-8.93,0-14.24-3.56-14.24-9.14,0-3.83,2.68-6,6.58-7.26a5.18,5.18,0,0,1-3.9-5.17,5.48,5.48,0,0,1,3.84-5.11,8.86,8.86,0,0,1-3-6.86c0-5.78,4.64-9.88,11.09-9.88a12.42,12.42,0,0,1,4,.61Zm-24,33.27c0,3.69,3.16,5.78,9.61,5.78,6.26,0,10-2.15,10-5.92,0-3.09-1.82-4.43-7.73-4.84l-7-.47C283,705.57,281,707.32,281,710.14Zm16.54-24c0-3.76-2.49-6.25-6.66-6.25s-6.72,2.49-6.72,6.25,2.49,6.32,6.72,6.32S297.54,689.91,297.54,686.14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.07,698.78l3.63-2.08a8.88,8.88,0,0,0,8.07,4.7c3.76,0,5.91-1.61,5.91-4.17,0-3-2.42-3.69-7.26-5.1-4.36-1.28-8.4-3-8.4-8.27,0-4.84,4-7.6,9.14-7.6a10.81,10.81,0,0,1,9.28,4.51l-3.23,2.48a7.12,7.12,0,0,0-6-3.16c-3,0-4.84,1.42-4.84,3.57,0,2.62,1.68,3.36,6.59,4.77,4.71,1.28,9.21,3.16,9.21,8.53,0,4.71-3.16,8.27-10.15,8.27C328.85,705.23,324.89,702.27,323.07,698.78Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.51,665.51a3.36,3.36,0,1,1,6.72,0,3.36,3.36,0,0,1-6.72,0Zm1,11.36h4.7v27.82h-4.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.51,676.87h4.7l-.13,5.24c1.81-3.76,4.84-5.85,8.73-5.85a8.34,8.34,0,0,1,8.4,5.85,10.79,10.79,0,0,1,9.62-5.85c6.11,0,9.88,4,9.88,10.62v17.81h-4.64v-17.2c0-4.44-1.75-6.93-6.12-6.93s-7.46,3-7.46,8.54v15.59h-4.7v-17.2c0-4.44-1.75-6.93-6.05-6.93s-7.53,3-7.53,8.54v15.59h-4.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.65,676.87h4.64l-.14,6A11.65,11.65,0,0,1,435,676.26c7.6,0,13.45,6.19,13.45,14.45s-5.92,14.52-13.51,14.52a11.6,11.6,0,0,1-10.62-6.32v20h-4.64Zm23.93,13.84c0-6-3.77-10.28-9.61-10.28s-9.89,4.3-9.89,10.28,4,10.42,9.89,10.42S443.58,696.76,443.58,690.71Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.15,656.17h4.71v48.52h-4.71Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.46,665.51a3.37,3.37,0,0,1,6.73,0,3.37,3.37,0,0,1-6.73,0Zm1,11.36h4.71v27.82h-4.71Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.27,680.83h-4.5v-4h4.5V664.23c0-6.25,3.16-8.94,7.73-8.94a7.93,7.93,0,0,1,7.06,3.43L501,661.48a3.94,3.94,0,0,0-3.56-2c-2,0-3.43,1.14-3.43,4.7v12.64h7.46v4H494v23.86h-4.71Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505.67,665.51a3.36,3.36,0,1,1,6.72,0,3.36,3.36,0,0,1-6.72,0Zm1,11.36h4.71v27.82h-4.71Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M535,701.27a11.36,11.36,0,0,0,8.81-3.7l2.89,2.82c-2.55,2.89-6.25,4.84-11.7,4.84-9.14,0-15.05-6.32-15.05-14.45a14.26,14.26,0,0,1,14.38-14.52c8.94,0,14.32,6.86,14,16.07H524.62C525.23,697.64,528.86,701.27,535,701.27Zm8.61-12.51c-.4-4.77-3.43-8.53-9.28-8.53-5.31,0-8.87,3.43-9.61,8.53Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M554.8,690.71c0-8.26,5.91-14.45,13.44-14.45a11.46,11.46,0,0,1,10.69,6.32V656.17h4.64v48.52h-4.64l.13-6a11.7,11.7,0,0,1-10.75,6.52C560.71,705.23,554.8,699.05,554.8,690.71Zm24.33,0c0-6-4-10.28-9.88-10.28s-9.61,4.3-9.61,10.28,3.76,10.42,9.61,10.42S579.13,696.76,579.13,690.71Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M591.9,701.47a3.65,3.65,0,0,1,3.63-3.63,3.61,3.61,0,0,1,3.63,3.63,3.67,3.67,0,0,1-3.63,3.69A3.71,3.71,0,0,1,591.9,701.47Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.72,681.84c0-13.78,10.22-23.39,23.53-23.39,6.58,0,12.16,1.88,15.93,5.92l-3.3,3.29c-3-3.09-7-4.84-12.63-4.84-10.76,0-18.49,8.13-18.49,19s7.8,19,18.89,19c6.25,0,10.69-1.88,13.51-4.16v-9.41H643.58V683h18.15v15.93c-3.36,3.3-9.48,6.32-18.08,6.32C630,705.23,619.72,695.62,619.72,681.84Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M671.2,676.87h4.71l-.14,5.44c1.75-4.23,4.84-6,8.14-6a8.09,8.09,0,0,1,4.83,1.34l-1.81,4.1a6.52,6.52,0,0,0-3.83-1.07c-4,0-7.19,2.82-7.19,9.34v14.65H671.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M693,690.78a14.72,14.72,0,1,1,14.78,14.45A14.48,14.48,0,0,1,693,690.78Zm24.66,0c0-6-4-10.42-9.88-10.42s-10,4.44-10,10.42,4,10.42,10,10.42S717.64,696.76,717.64,690.78Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M726.85,676.87H732l6,15.32a31.58,31.58,0,0,1,1.28,4.3,23.46,23.46,0,0,1,1.41-4.3l7.26-15.73h.6l7.4,15.67a28,28,0,0,1,1.47,4.36,30.89,30.89,0,0,1,1.28-4.36l6-15.26h4.78L757.84,705.3h-.68l-7.66-16.74a22.48,22.48,0,0,1-1.34-4.1,28.28,28.28,0,0,1-1.35,4.1L739,705.3h-.67Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.2,696.29V680.83h-4.31v-4h4.31V662.35h4.63v14.52h7.8v4h-7.8v15.53c0,3.7,1.28,4.84,3.3,4.84a5.08,5.08,0,0,0,3.76-1.61l2.55,2.95a9,9,0,0,1-6.78,2.76C781.42,705.3,778.2,702.88,778.2,696.29Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M799.37,656.17h4.7v26.14a10.62,10.62,0,0,1,9.88-6c6.19,0,10.42,4.24,10.42,11.5v16.93h-4.71v-16.4c0-4.9-2.28-7.73-6.92-7.73-5.17,0-8.67,3.3-8.67,8.81v15.32h-4.7Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M865.16,687.69c0-5.38-2.42-7.46-6.52-7.46a9.51,9.51,0,0,0-8.13,4l-2.89-2.62c2.42-3.29,6-5.38,11.36-5.38,6.18,0,10.89,3.63,10.89,11.36v17.07h-4.71l.2-4.16a10.34,10.34,0,0,1-9.2,4.7c-5.92,0-10.22-2.69-10.22-8.47s4.71-8.4,10.55-8.4h8.67Zm-8.33,4.23c-3.56,0-6.32,1.28-6.32,4.64,0,3.16,2.35,4.84,6.72,4.84s7.93-2.35,7.93-6v-3.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.74,676.87h4.71l-.13,5.24c1.81-3.76,4.83-5.85,8.73-5.85a8.34,8.34,0,0,1,8.4,5.85,10.79,10.79,0,0,1,9.62-5.85c6.11,0,9.88,4,9.88,10.62v17.81h-4.64v-17.2c0-4.44-1.75-6.93-6.12-6.93s-7.46,3-7.46,8.54v15.59H898v-17.2c0-4.44-1.75-6.93-6-6.93s-7.53,3-7.53,8.54v15.59h-4.71Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.89,676.87h4.64l-.14,6a11.65,11.65,0,0,1,10.82-6.59c7.6,0,13.45,6.19,13.45,14.45s-5.92,14.52-13.51,14.52a11.6,11.6,0,0,1-10.62-6.32v20h-4.64Zm23.93,13.84c0-6-3.77-10.28-9.62-10.28s-9.88,4.3-9.88,10.28,4,10.42,9.88,10.42S954.82,696.76,954.82,690.71Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M967.05,656.17h4.7v48.52h-4.7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M981.36,665.51a3.36,3.36,0,0,1,6.72,0,3.36,3.36,0,0,1-6.72,0Zm1,11.36h4.7v27.82h-4.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M999.17,680.83h-4.5v-4h4.5V664.23c0-6.25,3.16-8.94,7.73-8.94a7.93,7.93,0,0,1,7.06,3.43l-3.09,2.76a4,4,0,0,0-3.57-2c-2,0-3.42,1.14-3.42,4.7v12.64h7.46v4h-7.46v23.86h-4.71Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1016.91,665.51a3.36,3.36,0,0,1,6.72,0,3.36,3.36,0,0,1-6.72,0Zm1,11.36h4.71v27.82h-4.71Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1046.22,701.27a11.36,11.36,0,0,0,8.8-3.7l2.89,2.82c-2.55,2.89-6.25,4.84-11.69,4.84-9.15,0-15.06-6.32-15.06-14.45a14.26,14.26,0,0,1,14.38-14.52c8.94,0,14.32,6.86,14,16.07h-23.66C1036.47,697.64,1040.1,701.27,1046.22,701.27Zm8.6-12.51c-.4-4.77-3.43-8.53-9.28-8.53-5.31,0-8.87,3.43-9.61,8.53Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1066,690.71c0-8.26,5.91-14.45,13.44-14.45a11.46,11.46,0,0,1,10.69,6.32V656.17h4.64v48.52h-4.64l.13-6a11.7,11.7,0,0,1-10.75,6.52C1072,705.23,1066,699.05,1066,690.71Zm24.33,0c0-6-4-10.28-9.88-10.28s-9.61,4.3-9.61,10.28,3.76,10.42,9.61,10.42S1090.37,696.76,1090.37,690.71Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1103.14,701.47a3.65,3.65,0,0,1,3.63-3.63,3.61,3.61,0,0,1,3.63,3.63,3.67,3.67,0,0,1-3.63,3.69A3.71,3.71,0,0,1,1103.14,701.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.18,506.34l60.5,71.06V506.34h19.24V608.16H171l-60.86-72.23v72.23H90.91V506.34Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.11,506.34v15.38H230v26.75h44.17v15.38H230v28.93h47.16v15.38H210.29V506.34Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.68,505a61.15,61.15,0,0,1,28.46,6.52,51.42,51.42,0,0,1,.22,91.18,64.39,64.39,0,0,1-57.58-.11,50.42,50.42,0,0,1-27.37-45.33A51.2,51.2,0,0,1,298.63,531a50,50,0,0,1,19.9-19.13Q331.21,505,347.68,505Zm-35.93,52.26a36.27,36.27,0,0,0,4.59,18.22A31.93,31.93,0,0,0,329.13,588a38.23,38.23,0,0,0,18.55,4.45q15.68,0,25.76-9.84t10.1-25.36A36.66,36.66,0,0,0,379,539a31.42,31.42,0,0,0-12.82-12.57,41.08,41.08,0,0,0-37.25,0A31.14,31.14,0,0,0,316.2,539,37.1,37.1,0,0,0,311.75,557.29Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.64,506.34q14.36,0,23.4,7.95t9,20.7a25.82,25.82,0,0,1-4.49,15.12q-4.47,6.45-13.29,10.17a29.66,29.66,0,0,1,8.67,7.14q3.78,4.51,9.4,15.23,9.33,18.51,13.85,25.51H603.28a120.27,120.27,0,0,1-6.12-10.71q-8.46-16.26-12.39-21.9a29.72,29.72,0,0,0-7.58-8,15,15,0,0,0-8.38-2.37h-7.15v43H542V506.34Zm-4.44,43.44q7.72,0,12.13-3.86t4.41-10.57q0-7-4.37-10.46t-12.46-3.46H561.66v28.35Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.84,505a61.15,61.15,0,0,1,28.46,6.52,50.17,50.17,0,0,1,20.15,18.81,51.41,51.41,0,0,1-19.93,72.37,64.39,64.39,0,0,1-57.58-.11,50.42,50.42,0,0,1-27.37-45.33A51.2,51.2,0,0,1,633.79,531a50.09,50.09,0,0,1,19.89-19.13Q666.37,505,682.84,505Zm-35.93,52.26a36.27,36.27,0,0,0,4.59,18.22A31.87,31.87,0,0,0,664.29,588a38.2,38.2,0,0,0,18.55,4.45q15.66,0,25.76-9.84t10.1-25.36A36.66,36.66,0,0,0,714.14,539a31.38,31.38,0,0,0-12.83-12.57,41.06,41.06,0,0,0-37.24,0A31.17,31.17,0,0,0,651.35,539,37.2,37.2,0,0,0,646.91,557.29Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758.07,506.34l25.36,62.83,26.68-62.83h16.61l26.83,63.05,25.29-63.05H899l-41.9,103.13h-6.64L818.34,534l-32.21,75.51h-6.41l-42-103.13Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1001.2,506.34v15.38H965.05v86.44H945.37V521.72H909.22V506.34Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1036.57,506.34V549.2h52.84V506.34h19.68V608.16h-19.68v-43h-52.84v43h-19.68V506.34Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M534.13,575.37l-29.59-29.49-29.61,29.5L485,585.77l10.34-10.31v13.17a61.41,61.41,0,0,1-10.17,3.06,48.52,48.52,0,0,1-8.92.8q-17,0-27.37-9.51t-10.39-25.11a36.85,36.85,0,0,1,4.78-18.62,31.9,31.9,0,0,1,13.44-12.79A42.93,42.93,0,0,1,476.54,522q17.93,0,36.44,9.4v-18A89.85,89.85,0,0,0,475.66,505a64.28,64.28,0,0,0-29.48,6.71,50.13,50.13,0,0,0-20.62,18.8,50.84,50.84,0,0,0-7.4,27,49.63,49.63,0,0,0,27.73,45.26,63.63,63.63,0,0,0,29.19,6.63,80.67,80.67,0,0,0,21.9-3,59,59,0,0,0,18-8.2V577.09l8.71,8.68Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.91,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 192.73,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 294.55,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 396.36,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 498.18,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 600,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 701.82,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 803.64,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 905.45,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1007.27,
    y: 506.34,
    width: 101.82,
    height: 101.82
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.91,
    y: 608.16,
    width: 50.91,
    height: 50.91
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40,
    y: 704.7,
    width: 50.91,
    height: 50.91
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40,
    y: 455.43,
    width: 50.91,
    height: 50.91
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1109.09,
    y: 704.7,
    width: 50.91,
    height: 50.91
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1109.09,
    y: 455.43,
    width: 50.91,
    height: 50.91
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.91,
    y: 506.34,
    width: 1018.18,
    height: 198.35
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40,
    y: 455.43,
    width: 1120,
    height: 300.17
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.89,453.12a46.72,46.72,0,0,1,8.46-.67c4.71,0,7.75.9,9.86,2.84a8.49,8.49,0,0,1,2.66,6.49,9,9,0,0,1-6.48,8.68v.15c2.63.93,4.19,3.37,5,6.92,1.09,4.76,1.88,8.06,2.59,9.38l-4.56,0c-.55-1-1.3-3.91-2.24-8.17-1-4.71-2.8-6.49-6.8-6.67l-4.16,0-.07,14.79-4.41,0Zm4.33,15.57,4.51,0c4.71,0,7.71-2.54,7.73-6.44,0-4.41-3.16-6.35-7.82-6.42a18.17,18.17,0,0,0-4.36.38Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1134.58,
    cy: 469.86,
    r: 23.43
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeogrowthLogo);
export default __webpack_public_path__ + "static/media/neogrowth_logo.931c568647a01562092dba60c1486a2d.svg";
export { ForwardRef as ReactComponent };